"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_bootstrap_1 = require("react-bootstrap");

var classnames_1 = __importDefault(require("classnames"));

require("./SzTooltip.scss");

function SzTooltip(_a) {
  var children = _a.children,
      className = _a.className,
      content = _a.content,
      trigger = _a.trigger,
      _b = _a.placement,
      placement = _b === void 0 ? 'bottom' : _b,
      _c = _a.id,
      id = _c === void 0 ? '' : _c;
  var tooltipClasses = classnames_1.default('sz-input-tooltip font-weight-bold', className);
  return react_1.default.createElement(react_bootstrap_1.OverlayTrigger, {
    placement: placement,
    trigger: trigger,
    overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, {
      id: id,
      className: tooltipClasses
    }, content)
  }, react_1.default.createElement("span", {
    className: "d-flex"
  }, children));
}

exports.SzTooltip = SzTooltip;
SzTooltip.defaultProps = {
  trigger: 'hover',
  placement: 'bottom'
};
exports.default = SzTooltip;